import styled from 'styled-components';
export const LogoWrapper = styled.svg `
  min-width: 12px;
  min-height: 12px;
  width: 100%;

  path.o {
    fill: var(--color-secondary-100);
  }

  path.l {
    fill: var(--color-feedback-success-90);
  }

  path.x {
    fill: var(--color-primary-100);
  }

  &.white path,
  &.white-o path.o,
  &.white-l path.l,
  &.white-x path.x {
    fill: var(--color-neutral-70);
  }

  &.black path {
    fill: var(--color-neutral-130);
  }
`;
